import React, { useState, useEffect } from 'react'

class User extends React.Component {
    constructor(props) {
        super(props);
        this.User = {
            uid: 0,
            photoURL:'',
            phoneNumber: '',
            emailVerified: '',
            email: '',
            displayName: '',
            statusName: 'Basic',
            approved: false,
            role: 0,
            roles: {
                base: 0,
                admin: 9,
                premium: 1,
                investor: 2
            }
        };

        this.user_premium_list = [
            // 'CTdZod8VWEco1CeWEU0BcLAAYLp2',
            // '3fW1SqTmI3SJFJu2R8bHkDnkGrU2',
            // 'Jz7WqtaafTatslAyAGGtS1FQCSo1'
        ];
        this.user_admin_list = [
            // 'WuubNXTPrndnHFko9ZcQKxZPo312'
        ]
    }

    setUser() {
        let User = JSON.parse(localStorage['user']);
        if (localStorage['userFromData'] != undefined && localStorage['userFromData'] != "undefined") {
            const u = JSON.parse(localStorage['userFromData']);
            User.role = u.role;
            // User.approved = u.approved ?? false;  // When I want to force new users to be approved then I will set this up.
            User.approved = true;
        }

        this.User.uid = User.uid;
        this.User.photoURL = User.photoURL;
        this.User.phoneNumber = User.phoneNumber;
        this.User.emailVerified = User.emailVerified;
        this.User.email = User.email;
        this.User.displayName = User.displayName;
        this.User.approved = User.approved;
        this.User.roles = {
            base: 0,
            admin: 9,
            premium: 1,
            investor: 2,
            college: 0,
        }

        this.User.role = User.role ?? this.User.roles.premium;
        //this.User.role = Object.values(this.User.roles).includes(User.role) ? User.role: this.User.roles.base;
        
        if (this.user_premium_list.includes(User.uid)) {
            this.User.role = this.User.roles.premium;
        }

        if (this.user_admin_list.includes(User.uid)) {
            this.User.role = this.User.roles.admin;
        }

        switch(this.User.role) {
            case this.User.roles.base:
                this.User.statusName = 'Cofouner Basic';
                break;
            case this.User.roles.premium:
                this.User.statusName = '🎁 Cofounder Plus';
                break;
            case this.User.roles.investor:
                this.User.statusName = '💡 Cofounder Investor';
                break;
            case this.User.roles.admin:
                this.User.statusName = '👑 Cofounder Admin';
                break;
            default:
                this.User.statusName = 'Cofounder Basic';
                break;
        }

        const u = JSON.parse(JSON.stringify(this.User));
        return u;
    }

    getUser() {
        return this.User;
    }
}

export default User;